import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const KRWSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg className={classNames("svg-icon", {
      [`svg-icon__size-${size}`]: size,
      [`svg-icon__type-${type}`]: type,
      [className]: className,
    })}
         width="20"
         height="20"
         viewBox="0 0 20 20"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         onClick={onClick}
         ref={refHandler}
         id={id}
         data-id={dataId ? `${dataId}-svg-icon` : ""}>
      <path
        d="M9.53358 4.07295C9.87285 4.07296 10.1702 4.301 10.2582 4.62862L11.3627 8.74971H13.4154L14.5199 4.62862C14.6273 4.22895 15.0381 3.9914 15.4379 4.09834C15.8379 4.20552 16.0752 4.61727 15.9682 5.01729L14.9682 8.74971H15.5004C15.9143 8.74991 16.2502 9.08576 16.2504 9.49971C16.2504 9.9138 15.9144 10.2495 15.5004 10.2497H14.5668L13.1137 15.6726C13.0258 16.0004 12.7285 16.2282 12.389 16.2282C12.0496 16.2282 11.7523 16.0005 11.6644 15.6726L10.2113 10.2497H8.85585L7.4037 15.6726C7.31586 16.0004 7.01845 16.2281 6.67909 16.2282C6.33963 16.2282 6.04234 16.0004 5.95448 15.6726L4.50135 10.2497H3.77967C3.36546 10.2497 3.02967 9.91392 3.02967 9.49971C3.02983 9.08563 3.36556 8.74971 3.77967 8.74971H4.09901L3.09901 5.01729C2.99197 4.61732 3.22936 4.2056 3.62928 4.09834C4.02922 3.99123 4.44086 4.22879 4.54823 4.62862L5.65272 8.74971H7.70546L8.80995 4.62862L8.85194 4.51045C8.97238 4.24756 9.2369 4.07309 9.53358 4.07295ZM6.05507 10.2497L6.67909 12.5798L7.30311 10.2497H6.05507ZM11.765 10.2497L12.389 12.5798L13.0131 10.2497H11.765ZM9.25721 8.74971H9.80995L9.53358 7.71944L9.25721 8.74971Z"
        fill="#888888"/>
    </svg>
  );
};
